import React from "react";
import { Box, IconButton } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function WhatsAppFloating() {
  const phoneNumber = "919962008680"; // <-- your WhatsApp number
  const defaultMessage = "Hi Vivaha Sangamam, I want to know more about your services!";

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    defaultMessage
  )}`;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 20, md: 30 },
        right: { xs: 20, md: 30 },
        zIndex: 9999,
      }}
    >
      <IconButton
        onClick={() => window.open(url, "_blank")}
        sx={{
          backgroundColor: "#25D366",
          width: { xs: 55, md: 65 },
          height: { xs: 55, md: 65 },
          borderRadius: "50%",
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          "&:hover": { backgroundColor: "#1ebe5a" },
        }}
      >
        <WhatsAppIcon sx={{ color: "#fff", fontSize: { xs: 32, md: 38 } }} />
      </IconButton>
    </Box>
  );
}
